<template>
  <v-flex class="week-day-box ma-1 mb-2 event-on-month">
    <v-icon small color="deep-purple">event</v-icon>
    <router-link :to="{ name: 'eventDetail', params: { eventId: event.event_id } }">
      <h4>{{ event.event_title }}</h4>
    </router-link>
    <div>
      {{ event.event_date | moment("h:mma") }}<span v-if="event.event_end"> - {{ event.event_end | moment("h:mma") }}</span>
    </div>
  </v-flex>
</template>

<script>
export default {
  props: ['event'],
}
</script>

<style scoped>
.event-on-month {
  border-left: 3px solid #673ab7; /* deep-purple — distinct from shifts */
}
</style>
